'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.actions = exports.types = undefined;

var _ActionCreatorHelper = require('./ActionCreatorHelper');

var _proptypes = require('proptypes');

var _proptypes2 = _interopRequireDefault(_proptypes);

var _config = require('../config.js');

var Config = _interopRequireWildcard(_config);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DateTimePropType(props, propName, componentName) {}

var typeToPropType = {
    'number': _proptypes2.default.number.isRequired,
    'string': _proptypes2.default.string.isRequired,
    'guid': _proptypes2.default.string.isRequired,
    'boolean': _proptypes2.default.bool.isRequired,
    'datetime': _proptypes2.default.number.isRequired
};

var _actions = _lodash2.default.map(Config.events, function (event, name) {
    return {
        type: name,
        propTypes: _lodash2.default.zipObject(_lodash2.default.map(event.fields, 'name'), _lodash2.default.map(event.fields, function (field) {
            return typeToPropType[field.type];
        }))
    };
});

var types = exports.types = (0, _ActionCreatorHelper.createTypes)(_actions);
var actions = exports.actions = (0, _ActionCreatorHelper.createActions)(_actions);